const settingsLocalization = {
  en: {
    generalSettings: 'General settings',
    tvSettings: 'TV settings',
    mediaSettings: 'Media settings',
    account: 'Account',
    accountNumber: 'Account number',
    accountPacket: 'IPTV packet',
    accountExpired: 'Account expired',
    accountMedia: 'Media',
    accountActiveMedia: 'Active',
    accountUnactiveMedia: 'Unactive',
    interface: 'Interface settings',
    interfaceFontSize: 'Font size',
    interfaceChannelIndicies: 'Channel indicies',
    interfaceGridTitle: 'Title under posters',
    interfaceExpandedInfo: 'Short description',
    interfaceMouseMode: 'Mouse control',
    autoMouseMode: 'Auto',
    alwaysMouseMode: 'Always',
    neverMouseMode: 'Never',
    interfaceSeekStep: 'Seek step',
    stream: 'Stream settings',
    streamBuffer: 'Buffer length (ms)',
    profile: 'Profile settings',
    profileStartScreen: 'Start screen',
    startScreenHome: 'Home screen',
    startScreenTv: 'Tv screen',
    startScreenLast: 'Last screen',
    profileTvStart: 'After TV start',
    tvStartLastPosition: 'Last program',
    tvStartLive: 'Live',
    tvStartNever: 'Channel list',
    tvBackButton: 'Back button action',
    tvBackPrevChannel: 'Previous channel',
    tvBackChannelList: 'Channel list',
    pipMode: 'Picture-in-picture mode',
    pipModeAlways: 'Always',
    pipModeInApp: 'Only when app launched',
    pipModeNever: 'Never',
    parentControl: 'Parent control',
    parentControlType: 'Parent control type',
    parentControlChangePass: 'Change parent password',
    oldPass: 'Old password',
    newPass: 'New password',
    confirmPass: 'Confirm password',
    passNotSame: 'Passwords not same',
    parentPassSuccessChange: 'Parent password succeful changed',
    channelControl: 'Channels control',
    channelControlAccessDenied: 'Access denied',
    channelControlAccessDenied2: 'Need parent password for access',
    about: 'About app',
    aboutVersion: 'App version',
    aboutDebug: 'Debug options',
    aboutPlayerLog: 'Write player log',
    aboutFetchLog: 'Write fetch log',
    aboutDevServer: 'Request from dev server',
    aboutSendReport: 'Send report',
    faq: 'FAQ',
    publicTerms: 'Public terms',
    support: 'Technical support 1198',
    logout: 'Logout',
    logoutTitle: 'Logout',
    logoutQuestion: 'Are you sure to want logout?',
    startAtBegin: 'Start at begin',
    openDetails: 'Open details',
    removeFromHistory: 'Remove from watch history',
    update: 'Update',
    updateQuestion: 'New IDC IPTV app version {0} is available.',
    updateRecommended: 'Recommend install this update',
    updateNeedPermissions:
      'Need grant app instalation permissions for auto-update app.',
    updateNeedPermissions2: 'Grant this permissions for IDC IPTV app.',
    updateProcess: 'Procced IDC IPTV apps update',
    updateError: 'Update error. Check device settings & Internet connention',
  },
  ru: {
    generalSettings: 'Общие настройки',
    tvSettings: 'Настройки телевидения',
    mediaSettings: 'Настройки медиатеки',
    account: 'Абонемент',
    accountNumber: 'Номер абонемента',
    accountPacket: 'Тариф IPTV',
    accountExpired: 'Окончание абонемента',
    accountMedia: 'Медиатека',
    accountActiveMedia: 'Активна',
    accountUnactiveMedia: 'Неактивна',
    interface: 'Настройки интерфейса',
    interfaceFontSize: 'Размер шрифта',
    interfaceChannelIndicies: 'Номера каналов',
    interfaceGridTitle: 'Названия под постерами',
    interfaceExpandedInfo: 'Краткое описание',
    interfaceMouseMode: 'Управление мышью',
    autoMouseMode: 'Автоматически',
    alwaysMouseMode: 'Всегда',
    neverMouseMode: 'Никогда',
    interfaceSeekStep: 'Шаг перемотки',
    stream: 'Настройки вещания',
    streamBuffer: 'Время буферизации',
    profile: 'Настройки профиля',
    profileStartScreen: 'Стартовая страница',
    startScreenHome: 'Главная',
    startScreenTv: 'Телевидение',
    startScreenLast: 'Последний экран',
    profileTvStart: 'При запуске ТВ',
    tvStartLastPosition: 'Последняя запущенная передача',
    tvStartLive: 'Прямой эфир',
    tvStartNever: 'Список каналов',
    tvBackButton: 'Действие кнопки "Назад"',
    tvBackPrevChannel: 'Предыдущий канал',
    tvBackChannelList: 'Список каналов',
    pipMode: 'Режим картинка в картинке',
    pipModeAlways: 'Всегда',
    pipModeInApp: 'Только в приложении',
    pipModeNever: 'Никогда',
    parentControl: 'Родительский контроль',
    parentControlType: 'Тип родительского контроля',
    parentControlChangePass: 'Изменить родительский пароль',
    oldPass: 'Старый пароль',
    newPass: 'Новый пароль',
    confirmPass: 'Подтвердить пароль',
    passNotSame: 'Пароли не совпадают',
    parentPassSuccessChange: 'Родительский пароль успешно изменён',
    channelControl: 'Управление каналами',
    channelControlAccessDenied: 'Доступ ограничен',
    channelControlAccessDenied2: 'Требуется родительский пароль для доступа',
    about: 'О приложении',
    aboutVersion: 'Версия приложения',
    aboutDebug: 'Настройки отладки',
    aboutPlayerLog: 'Записывать журнал плеера',
    aboutFetchLog: 'Записывать журнал запросов',
    aboutDevServer: 'Запрашивать dev-сервер',
    aboutSendReport: 'Отправить отчёт',
    faq: 'Вопросы и ответы',
    publicTerms: 'Публичные условия',
    support: 'Техническая поддержка 1198',
    logout: 'Выйти из абонемента',
    logoutTitle: 'Выход',
    logoutQuestion: 'Вы действительно хотите выйти?',
    startAtBegin: 'Запустить с начала',
    openDetails: 'Открыть карточку фильма',
    removeFromHistory: 'Удалить из истории просмотра',
    update: 'Обновление',
    updateQuestion:
      'Доступна новая версия {0} программы просмотра IPTV от IDC.',
    updateRecommended:
      'Рекомендуем обновить приложение в автоматическом режиме',
    updateNeedPermissions:
      'Для автоматического обновления необходимо предоставить приложению права для установки приложений.',
    updateNeedPermissions2:
      'Предоставьте это разрешение для приложения "IDC Телевидения".',
    updateProcess: 'Идёт обновление приложения IDC Телевидение',
    updateError:
      'Ошибка обновления. Проверьте настройки устройства и Интернет-соединение',
  },
};

export default settingsLocalization;
